
export class MintDateUnavailable extends Error {
  readonly mintDateUnavailable = true;
  constructor(message = 'Mint date is unavailable') {
    super(message);
  }
}

export class InsufficientFundsError extends Error {
  constructor(
    public insufficientFunds = true,
    message = 'This account has insufficient funds'
  ) {
    super(message);
  }
}
